import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "SsoChangePassword": () => import("../components/chnagePassword/SsoChangePassword.vue"),
    "PrivacyComponent": () => import("../components/privacy/PrivacyComponent.vue")
};

export default globals;
